import React, { Component } from 'react';
import {appName} from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Helmet} from "react-helmet";
import {Row,Col,Table,Modal} from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";

import PageTitle from '../../../containers/PageTitle';

class Services extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage:1,
			dataList: [],
			dataView: [],
			editData: [],
		}
		
		this.handleSearch = this.handleSearch.bind(this);
		this.loadData = this.loadData.bind(this);
	}
	
	componentDidMount(){
		
		this.loadData();
	}
	
	loadData(){
		this.setState({showLoader:true});
		var token = Reqst.TimeStamp();
		Reqst.axGet('qualification/getserviceslist/'+this.state.masterId+'/'+this.state.companyId+'/'+token).then(res=>{
			if(res['data'].status=='1')
			{
				this.setState({dataList: res['data'].data, dataView: res['data'].data, showLoader:false});	
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false});	
			}
		});
	}


	
	handleSearch(e){
		try{
			var list = this.state.dataList;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function(obj){
				const name = obj.service.toUpperCase();
				return ((name.indexOf(v)>-1));
			});
			this.setState({dataView:l});
		}
		catch(error){
			console.log(error);
		}
	}
	
	
	
	render(){
		
		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		 const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		 const currentTodos = this.state.dataView.slice(indexOfFirstTodo, indexOfLastTodo);
		 let sno = indexOfFirstTodo + 1;
		 
		return(
			<div>
			
				<Helmet>
					<title>{appName} | Services</title>
				</Helmet>
				
				<PageTitle title="Services" loading={this.state.showLoader} > 
					<div className="text-right">
					
						<button className="btn btn-info btn-sm" onClick={this.loadData} >
							<i className="fa fa-refresh"></i> 
						</button>
					</div>
				</PageTitle>
				
				<Row style={{ marginBottom: 5 }} >
					<Col md={3} >
						<input type="text" className="form-control input-sm" placeholder="Search by [Name]" onChange={this.handleSearch} />
					</Col>
					
					<Col md={7} >
						<div className="text-right" >
							
							
						</div>
					</Col>
				</Row>
				
				<Row>
					
					<Col md={12} >
						<Table hover responsive className="list-table">
							<thead>
								<tr>
									<th width="60" >Sl.No</th>
									<th>Service ID</th>
									<th>Service</th>
							
								</tr>
							</thead>
							<tbody>
							{
								currentTodos.map((item,key)=>{
									return <tr key={key} >
										<td>{sno++}</td>
										<td>{item.serviceid}</td>
										<td>{item.service}</td>
									</tr>;
								})
							}
							</tbody>
						</Table>
					</Col>
				</Row>
				
				<Row>
					<Col md={1} >
						<select className="form-control input-sm" onChange={(e)=>{this.setState({activePage:1,currentPage:Number(1), todosPerPage: e.target.value})}} >
							<option value="10"> 10 </option>
							<option value="15"> 15 </option>
							<option value="20"> 20 </option>
							<option value="50"> 50 </option>
							<option value="100"> 100 </option>
						</select>
					</Col>
					<Col md={10} >
						 <Pagination
						  activePage={this.state.activePage}
						  itemsCountPerPage={this.state.todosPerPage}
						  totalItemsCount={(this.state.dataView).length}
						  pageRangeDisplayed={7}
						  onChange={(pN)=>{this.setState({activePage:pN, currentPage: Number(pN)})}}
						/>
					</Col>
				</Row>
				
				
			</div>
		);
	}
	
}
export default Services;